module.exports = __webpack_public_path__ + "img/quinton.39a31d4c.svg";